import React, { FC, ReactElement, useEffect } from 'react'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { ErrorLanguage } from '../../../../../i18n'
import { LanguageUtils } from '../../../../React/Common/Utils/LanguageUtils'
import { Branding } from '../../../../React/Common/API/BrandingAPI'
import { useBranding } from '../../../../React/Common/Hooks/useBranding'
import { DarkModeType, useDarkMode } from '../../../../React/Common/Hooks/useDarkMode'

export const ErrorView: FC = (): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(ErrorLanguage.NAME)

    const { isDarkMode, darkModeSwitch }: DarkModeType = useDarkMode()
    const branding: Nullable<Branding> = useBranding()

    useEffect((): void => {
        window.document.title = language.get(ErrorLanguage.Error_PageTitle)
    }, [])

    return (
        <div className='router-error'>
            {darkModeSwitch}
            {branding?.BrandingConfig?.imagery?.mainLogo ? (
                <div className='re-main-logo-container'>
                    <a
                        href={branding?.BrandingConfig?.links?.mainSiteLink?.url}
                        target={branding?.BrandingConfig?.links?.mainSiteLink?.target}
                        title={branding?.BrandingConfig?.links?.mainSiteLink?.title}
                        className='re-main-logo'
                    >
                        <img
                            className='re-logo'
                            src={
                                isDarkMode
                                    ? branding?.BrandingConfig?.imagery?.mainLogo
                                    : branding?.BrandingConfig?.imagery?.mainLogoForWhiteBG
                            }
                            alt='Main logo'
                        />
                    </a>
                </div>
            ) : (
                <></>
            )}

            <h1 className='re-title'>{language.get(ErrorLanguage.Error_Title)}</h1>
            <h2 className='re-subtitle'>{language.get(ErrorLanguage.Error_SubTitle)}</h2>
            <div className='re-content'>
                {LanguageUtils.formatLanguageEntry(language.get(ErrorLanguage.Error_Message))}
            </div>
        </div>
    )
}
